import moment from 'moment';
import { MOMENT_DATE_FORMAT } from '../../constants/date_format';
import { ACADEMIC_VIEW_TYPE, FACILITIES_VIEW_TYPE } from '../../constants';

class Message {
    id: number | null;
    message: string;
    date: Date;
    lastUpdatedBy: string;
    schoolId: number | null;
    campusId: number | null;

    static fromDto(messageDto, viewType: string) {
        return new Message(messageDto.id, messageDto.message, messageDto.date, messageDto.lastUpdatedBy, messageDto.schoolId, messageDto.campusId, viewType);
    }

    constructor(id: number, message: string, date: string, lastUpdatedBy: string, schoolId: number, campusId: number, viewType: string) {
        this.id = id;
        this.message = message;
        this.date = moment(date, MOMENT_DATE_FORMAT).toDate();
        this.lastUpdatedBy = lastUpdatedBy;

        if (viewType === ACADEMIC_VIEW_TYPE) this.schoolId = schoolId;

        if (viewType === FACILITIES_VIEW_TYPE) this.campusId = campusId;
    }
}

export default Message;
